import { render, staticRenderFns } from "./AllOpenOrders.vue?vue&type=template&id=6d51d7aa&scoped=true"
import script from "./AllOpenOrders.vue?vue&type=script&lang=js"
export * from "./AllOpenOrders.vue?vue&type=script&lang=js"
import style0 from "./AllOpenOrders.vue?vue&type=style&index=0&id=6d51d7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51d7aa",
  null
  
)

export default component.exports